import { createFileRoute } from '@tanstack/react-router'
import { InsuranceDashboard } from '@/features/insurance-dashboard'

export const Route = createFileRoute('/_authenticated/insurance-dashboard')({
  component: InsuranceDashboard,
}) 